module.exports = __webpack_public_path__ + "static/media/model_S.7ec60210.png";